



























































































































































































import { Component, Vue } from "vue-property-decorator";
import {
	RedCapital,
	SelectedCountry,
	RedCapitalConfig
} from "@/configuration";
import { mapState } from "vuex";
import ItemRadian from '@/components/radian/Item.vue'
import CarouselFactoringElect from '@/components/radian/CustomCarousel.vue'
import { EventBus } from "@/main";
@Component({
	metaInfo: {
		title: "RADIAN ",
		//titleTemplate: TitleTemplatePublic,
		htmlAttrs: {
			// @ts-ignore
			lang: RedCapital[SelectedCountry].Lang
		}
	},
	computed: {
		...mapState(["user", "amountFinanced"]),
		projectsVisibility() {
			return (
				this.$store.state.user != null ||
				RedCapitalConfig(SelectedCountry).Project.PublicVisibility
			);
		}
	},
	data() {
		return {
			RedCapital,
			SelectedCountry,
			participantesRadian: [
				{
					image: '/images/radian/facturador_electronico.png',
					title: 'Facturador electrónico',
				},
				{
					image: '/images/radian/proveedor_tecnologico.png',
					title: 'Proveedor Tecnológico',
				},
				{
					image: '/images/radian/coins.png',
					title: 'Factor',
				},
				{
					image: '/images/radian/negociación_electronica.png',
					title: 'Sistema de negociación electrónica (SNE)',
				},
			],
			actoresFactoringElectronico: [
				{
					image: '/images/radian/adquiriente-pagador.png',
					title: 'Adquiriente - Pagador',
				},
				{
					image: '/images/homeView/home-wd4.png',
					title: 'Emisor - Proveedor',
				},
				{
					image: '/images/radian/rc.png',
					title: 'Fondeador',
				},
				{
					image: '/images/radian/dian.png',
					title: 'Registro de la Factura Electrónica de Venta como Título Valor - RADIAN',
				},
			],
			infoAntesyAhora: [
				{
					actor: 'Emisor - Proveedor',
					evento: 'Radicación', 
					factura_electronica: 'Se envía por correo electrónico',
					factura_radian: 'Factura electrónica válida en RADIAN'
				},
				{
					actor: 'Adquiriente - Pagador',
					evento: 'Acuse de recibido', 
					factura_electronica: 'Respuesta por correo electrónico',
					factura_radian: 'Evento en RADIAN'
				},
				{
					actor: 'Adquiriente - Pagador',
					evento: 'Rechazo', 
					factura_electronica: 'Carta o correo electrónico',
					factura_radian: 'Evento en RADIAN'
				},
				{
					actor: 'Emisor - Proveedor',
					evento: 'Aceptación táctica', 
					factura_electronica: 'Tres días hábiles desde la fecha de radiación de la factura',
					factura_radian: 'Evento en RADIAN'
				},
				{
					actor: 'Adquiriente - Pagador',
					evento: 'Aceptación expresa', 
					factura_electronica: 'Carta o correo electrónico',
					factura_radian: 'Evento en RADIAN'
				},
				{
					actor: 'Fondeador - Emisor',
					evento: 'Endoso', 
					factura_electronica: 'Firma de endoso o cesión',
					factura_radian: 'Evento en RADIAN'
				},
				{
					actor: 'Adquiriente - Pagador',
					evento: 'Informe de pago', 
					factura_electronica: 'Informe por correo electrónico',
					factura_radian: 'Validación de legítimo tenedor en RADIAN'
				},
				{
					actor: 'Adquiriente - Pagador',
					evento: 'Pago', 
					factura_electronica: 'Informe por correo electrónico',
					factura_radian: 'Evento en RADIAN'
				}
			]
		};
	},
	methods:{
		gohablemos(){
			EventBus.$emit("goHablemos");
		},
	},
	components: {
		ItemRadian,
		CarouselFactoringElect
	}
})
export default class HomeNew extends Vue{}
